// extracted by mini-css-extract-plugin
export default {"container":"over-card_container__18ZAS","inner":"over-card_inner__3UBjC","thumbnail":"over-card_thumbnail__1tO_O","footer":"over-card_footer__1oX2p","label":"over-card_label__2KwHB"};